export default "__VITE_ASSET__d355e6ba__"